import Tooltip from '@material-ui/core/Tooltip';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';

import materialTheme from '../../reactMaterialTheme';
import './Icon.css';

const iconOptions = {
  banner: 'swap_horiz',
  carousel: 'view_carousel',
  clickout: 'open_in_new',
  'hosted-video': 'videocam',
  scroller: 'panorama_vertical',
  slideshow: 'view_carousel',
  video: 'videocam',
  undefined: 'folder'
};

const tooltipOptions = {
  banner: 'Enhanced Display',
  carousel: 'Full Ad Carousel',
  clickout: 'Display',
  'hosted-video': 'Video',
  scroller: 'Scroller',
  slideshow: 'Thumbnail Carousel',
  video: 'Rich Video',
  undefined: 'Ad Group'
};

const Icon = ({ action, isiText, placement }) => {
  const isIsi = !!isiText;
  const isSvg = isIsi;

  const icon = isIsi ? 'isi-icon' : iconOptions[action];
  const tooltip = tooltipOptions[action];
  return (
    <div className="creative-icon">
      <MuiThemeProvider theme={materialTheme}>
        <Tooltip
          title={tooltip}
          placement={placement}
          classes={{ tooltip: `tooltip--${placement}` }}
        >
          {isSvg ? (
            <span className={`tooltip ad-type-svg ${icon}`} />
          ) : (
            <i className={`material-icons ad-type-tooltip ${icon}`}>{icon}</i>
          )}
        </Tooltip>
      </MuiThemeProvider>
    </div>
  );
};

Icon.propTypes = {
  action: PropTypes.string,
  isiText: PropTypes.string,
  placement: PropTypes.string
};

Icon.defaultProps = {
  action: undefined,
  isiText: '',
  placement: 'top'
};

export default Icon;
